var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('devices-tables',{attrs:{"userDevices":_vm.userDevices,"showUserDevices":_vm.showUserDevices,"showLocationValue":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }